// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-components-SearchBar-AutoComplete-style__container--2WCZA"};